/* V10.60.1 Seedkeeper field-guide image resilience. */
(() => {
  const markMissing = (img) => {
    const figure = img.closest('figure.aonsk-field-figure');
    if (figure) figure.classList.add('aonsk-field-figure--missing');
  };
  const inspect = () => {
    document.querySelectorAll('.aonsk-field-guide-body figure.aonsk-field-figure img').forEach((img) => {
      if (img.complete && img.naturalWidth === 0) markMissing(img);
      img.addEventListener('error', () => markMissing(img), { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inspect, { once: true });
  else inspect();
})();
